(() => {
  const policyBody = document.querySelector('.shopify-policy__body .rte');
  if (!policyBody) return;

  const rawCssNodes = [...policyBody.childNodes].filter((node) => {
    if (node.nodeType !== Node.TEXT_NODE) return false;
    const text = node.textContent || '';
    return text.includes("@import url('https://fonts.googleapis.com") && text.includes('--ink:#1a1814');
  });

  if (rawCssNodes.length === 0) return;

  rawCssNodes.forEach((node) => node.remove());

  [...policyBody.children].forEach((element) => {
    const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
    const isDuplicateLogo = element.classList.contains('logo') && text === 'ModernJapanCrafts';
    const isDuplicateCopyright = element.tagName === 'P' && text.startsWith('© 2025 EchoCrafts Inc.');
    const isDuplicateContact =
      element.tagName === 'P' && text.includes('contact@echocrafts.co.jp') && text.includes('modernjapancrafts.com');

    if (isDuplicateLogo || isDuplicateCopyright || isDuplicateContact) element.remove();
  });

  policyBody.querySelectorAll('table').forEach((table) => {
    if (table.parentElement?.classList.contains('mjc-policy-table-scroll')) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'mjc-policy-table-scroll';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });

  policyBody.closest('.shopify-policy__container')?.classList.add('mjc-policy-cleanup');
})();
